export default __webpack_public_path__ + "static/media/review11.3d2d9f38.jpg";